import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.742 3c.322 0 .58.26.58.58v1.162a.58.58 0 0 1-.58.58H2.58A.58.58 0 0 1 2 4.743V3.58C2 3.26 2.26 3 2.58 3zm9.677.58a.58.58 0 1 1 0 1.162H6.065a.58.58 0 1 1 0-1.161zm0 3.872a.58.58 0 0 1 .581.58.58.58 0 0 1-.58.58H6.064a.58.58 0 0 1-.581-.58.58.58 0 0 1 .58-.58zm0 3.87a.58.58 0 0 1 .581.581.58.58 0 0 1-.58.58H6.064a.58.58 0 0 1-.581-.58.58.58 0 0 1 .58-.58zM2 7.453c0-.322.26-.581.58-.581h1.162a.58.58 0 0 1 .58.58v1.162a.58.58 0 0 1-.58.58H2.58A.58.58 0 0 1 2 8.614zm1.742 3.29a.58.58 0 0 1 .58.58v1.162a.58.58 0 0 1-.58.58H2.58a.58.58 0 0 1-.581-.58v-1.161c0-.322.26-.581.58-.581z"
    }, null, -1)
  ]))]))
}
export default { render: render }